<template>
    <div
        class="sm:col-span-1"
        data-spec-class="description-list__item"
    >
        <slot />
    </div>
</template>
